<template>
  <commonSelect
    :value="value"
    @input="v=>$emit('input',v)"
    @change="v=>$emit('change',v)"
    :multiple="multiple"
    placeholder="请选择考试类别"
    idKey="DataName"
    labelKey="DataName"
    :get-data-func="getDataFunc"
    :disabled="disabled"
    :clearable="clearable"
  />
</template>
<script>
import api from "@/api/basic/basic/data";
import commonSelect from "@/components/common/select";
export default {
  props: {
    value: {},
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  components: { commonSelect },
  data() {
    return { api, data: [] };
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        this.api.list({ClassName:'考试类别'}).then((res) => {
          // 
          this.data = res.Data;
          resolve({ Data: res.Data });
        });
      });
    },
    getData() {
      return this.data;
    },
  },
};
</script>

